/**
 * 
 * This gonna be the component that does all the rigging and shiz
 */

import React from 'react';
import {
    Drawer, Button, Checkbox, Icon,
    Tabs, Card, Collapse, Modal,
    Slider, Tag, Spin, Divider, message,
    notification, Tooltip, Input, Layout,
    Row, Col

} from 'antd';
import { FormatPainterOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { GUI } from 'three/examples/jsm/libs/dat.gui.module.js';
import { useRef, useState } from 'react'
import { Canvas, useFrame, Dom, useThree } from 'react-three-fiber'
import OrbControls from './controls'
import Scene from './scene'
import { Man, Woman } from './charachters'
import { RigControl } from './charController';

const { Header, Footer, Sider, Content } = Layout;
const { Panel } = Collapse;
const { TabPane } = Tabs;


export class Rig extends React.Component {
    /**
     * This is the main canvas where a peeps gonna draw
     * @param {T} props 
     */
    constructor(props) {
        super(props);


        this.state = {
            // btn style
            btnStyle: {
                margin: '10px',
                backgroundColor: '#ff8c19',
                color: 'white',
            },

            groundVisible: true,

            load_rig: false,


            // States for the controller bonez and shiz
            modelBones: {
                "spine": {
                    "desc": "Use this to control the entire body",
                    "rotation": {
                        "x": 0.17114832534406585,
                        "y": 0.0006280805616158963, 
                        "z": -0.015464980438061887
                    },
                    "scale": {
                        "x": 1, "y": 1, "z": 1
                    },
                    
                },
                "spine001": {
                    "desc": "Use this to control the body from above the hips",
                    "rotation": {
                        "x": -0.07310195639084988, "y": -0.002063952157980884, "z": 0.03430750675033413
                    }
                },
                "spine002": {
                    "desc": "Use this to control the body from above the belly button",
                    "rotation": {
                        "x": -0.40960043895701936, "y": 0.007925089291082677, "z": -0.026145895643318064
                    }
                },
                "spine005": {
                    "desc": "Use this to control the head muscles",
                    "rotation": {
                        "x": 0.20854271976712987, "y": 5.035766760522434e-9, "z": 4.874657693419721e-8
                    }
                },
                "shoulderL": {
                    "desc": "Use this to control the left shoulder",
                    "rotation": {
                        "x": -1.4364658224925961, "y": 0.011260281282109768
                    }
                },
                "shoulderR": {
                    "desc": "Use this to control the right shoulder",
                    "rotation": {
                        "x": -1.436465562246387, "y": -0.01126016086800014
                    }
                },
                "upper_armL": {
                    "desc": "Use this to control the left upper arm",
                    "rotation": {
                        "x": 1.703659037105251, "y": 1.433473734920247, "z": -2.8659926036345937
                    }
                },
                "upper_armR": {
                    "desc": "Use this to control the right upper arm",
                    "rotation": {
                        "x": 1.7036583076720468, "y": -1.4334728925928975, "z": 2.865992630924074
                    }
                },
                "forearmL": {
                    "desc": "Use this to control the left forearm",
                    "rotation": {
                        "x": 0.30549414695002053, "y": 0.23725931161940766, "z": -0.04308824444355502
                    }
                },
                "forearmR": {
                    "desc": "Use this to control the right forearm",
                    "rotation": {
                        "x": 0.305494197734409, "y": -0.23725945189978734, "z": 0.04308833919494419
                    }
                },
                "breastL": {
                    "desc": "Use this to control the left breast",
                    "scale": {
                        "x": 1, "y": 1, "z": 1
                    }
                },
                "breastR": {
                    "desc": "Use this to control the right breast",
                    "scale": {
                        "x": 1, "y": 1, "z": 1
                    }
                },
                "thighL": {
                    "desc": "Use this to control the left thigh",
                    "rotation": {
                        "x": 2.9656686914406953, "y": 0.007619907096489391, "z": 0.052862807455962155
                    }
                },
                "thighR": {
                    "desc": "Use this to control the right thigh",
                    "rotation": {
                        "x": 2.965538977999858, "y": -0.0009677896268715004, "z": -0.08307863455696293
                    }
                },
                "footL": {
                    "desc": "Use this to control the left foot",
                    "rotation": {
                        "x": -1.4812161503325219, "z": -0.2638212678910176
                    }
                },
                "footR": {
                    "desc": "Use this to control the right foot",
                    "rotation": {
                        "x": -1.4812165664684513, "z": 0.26382070351153825
                    }
                },
                "shinL": {
                    "desc": "Use this to control the left shin",
                    "rotation": {
                        "x": 0.14328747620373966, "y": -0.01304259008716047
                    }
                },
                "shinR": {
                    "desc": "Use this to control the right shin",
                    "rotation": {
                        "x": 0.1432877399719645, "y": 0.013042578620761521
                    }
                },
            },

            // grouping represents the binding of tabs to their respective bone state
            grouping: {
                "Body": ["spine", "breastR", "breastL"],
                "Head": ["spine005"],
                "Back": ["spine001", "spine002"],
                "Arms": ["shoulderL", "shoulderR", "upper_armL", "upper_armR", "forearmR", "forearmL"],
                "Legs": ["thighL", "thighR", "footR", "footL", "shinL", "shinR"]

            },

            rz: 0,

            axis_color_lookup :{
                "x":"#ff9191",
                "y":"#c4ff99",
                "z":"#abfff9"
            },

            controlConfig:  {
                "spine": {
                    "name": "Body",
                    "rotation": {
                        "x": [-Math.PI, Math.PI],
                        "y": [-Math.PI, Math.PI], 
                        "z": [-Math.PI, Math.PI]
                    },
                    "scale": {
                        "x": 
                        [0, 2], "y": [0,2], "z": [0,2]
                    },
                    
                },
                "spine001": {
                    "name": "Hips",
                    "rotation": {
                        "x":[-2,2], "y": [-0.9, 0.9], "z": [-0.9, 0.9]
                    }
                },
                "spine002": {
                    "name": "Torso",
                    "rotation": {
                        "x": [-0.8, 0.8], "y": [-0.9, 0.9], "z":  [-0.5, 0.5]
                    }
                },
                "spine005": {
                    "name": "Head",
                    "rotation": {
                        "x": [-Math.PI*0.5, Math.PI*0.5], "y": [-Math.PI*0.5, Math.PI*0.5], "z": [-0.8, 0.8]
                    }
                },
                "shoulderL": {
                    "name": "Left Shoulder",
                    "rotation": {
                        "x": [-Math.PI, 0.3], "y": [-0.8, 0.0]
                    }
                },
                "shoulderR": {
                    "name": "Right Shoulder",
                    "rotation": {
                        "x": [-Math.PI, 0.3], "y": [-0.8, 0.0]
                    }
                },
                "upper_armL": {
                    "name": "Left Upper Arm",
                    "rotation": {
                        "x": [-1.44, Math.PI], "y": [-2,0.8], "z":  [-Math.PI, -0.5]
                    }
                },
                "upper_armR": {
                    "name": "Right Upper Arm",
                    "rotation": {
                        "x": [-1.44, Math.PI], "y": [-2,0.8], "z":  [0.5, Math.PI]
                    }
                },
                "forearmL": {
                    "name": "Left Forearm",
                    "rotation": {
                        "x": [0,2.69], "y": [-Math.PI*0.5, Math.PI*0.5], "z": [-Math.PI*0.5, Math.PI*0.5]
                    }
                },
                "forearmR": {
                    "name": "Right Forearm",
                    "rotation": {
                        "x": [0,2.69], "y": [-Math.PI*0.5, Math.PI*0.5], "z": [-Math.PI*0.5, Math.PI*0.5]
                    }
                },
                "breastL": {
                    "name": "Left Breast",
                    "scale": {
                        "x": [1,1.5], "y":  [1,1.5], "z":  [1,1.5]
                    }
                },
                "breastR": {
                    "name": "Right Breast",
                    "scale": {
                        "x": [1,1.5], "y":  [1,1.5], "z":  [1,1.5]
                    }
                },
                "thighL": {
                    "name": "Left Thigh",
                    "rotation": {
                        "x":[0.93,Math.PI], "y": [-Math.PI*0.5, Math.PI*0.5], "z": [-Math.PI*0.5,0]
                    }
                },
                "thighR": {
                    "name": "Right Thigh",
                    "rotation": {
                        "x":[0.93,Math.PI], "y": [-Math.PI*0.5, Math.PI*0.5], "z": [0, Math.PI*0.5]
                    }
                },
                "footL": {
                    "name": "Left Foot",
                    "rotation": {
                        "x": [-2,0.76], "z":  [-0.5,0.5]
                    }
                },
                "footR": {
                    "name": "Right Foot",
                    "rotation": {
                        "x": [-2,0.76], "z":  [-0.5,0.5]
                    }
                },
                "shinL": {
                    "name": "Left Shin",
                    "rotation": {
                        "x":[0,2.46], "y": [-Math.PI*0.5, 1]
                    }
                },
                "shinR": {
                    "name": "Right Shin",
                    "rotation": {
                        "x":[0,2.46], "y": [-Math.PI*0.5, 1]
                    }
                },
            }

        }



    }

    getRigBones = (bones) => {
        this.setState({
            modelBones: bones
        })
    }

    toggleGroundVisibility = () => {
        this.setState({
            groundVisible: !this.state.groundVisible
        })
    }

    boneChange = (e, part, key, axis) => {
        var newBone = this.state.modelBones
        newBone[part][key][axis] = e
        this.setState({
            modelBones: newBone
        })
    }

    renderComponentPanel = (key, part, obj) => {

        switch (key) {
            case "desc":
                return (
                    <p>{obj['desc']}</p>
                )
                break;
            case "scale":
                return Object.keys(obj['scale']).map((axis, idx) => (
                    <div>
                        <p>Scale along: {axis}</p>
                        <Slider
                            style={{
                                background:this.state.axis_color_lookup[axis]
                            }}
                            min={this.state.controlConfig[part]["scale"][axis][0]}
                            max={this.state.controlConfig[part]["scale"][axis][1]}
                            onChange={(e) => { this.boneChange(e, part, key, axis) }}
                            value={this.state.modelBones[part][key][axis]}
                            step={0.01}
                        />
                    </div>
                ))
                break;
            case "rotation":
                return Object.keys(obj['rotation']).map((axis, idx) => (
                    <div>
                        <p>Rotate along: {axis}</p>
                        <Slider
                            style={{
                                background:this.state.axis_color_lookup[axis]
                            }}
                            min={this.state.controlConfig[part]["rotation"][axis][0]}
                            max={this.state.controlConfig[part]["rotation"][axis][1]}
                            onChange={(e) => { this.boneChange(e, part, key, axis) }}
                            value={this.state.modelBones[part][key][axis]}
                            step={0.01}
                        />
                    </div>
                ))
                break;
            default:
            // code block
        }
    }



    render() {
        return (
            <Drawer

                placement="bottom"
                // width={!!this.props.siderOffset?window.innerWidth-this.props.siderOffset:"100%"}
                width="100%"
                height="100%"
                onClose={this.props.on3DClose}
                visible={this.props.Drawer3DVisisble}
                bodyStyle={{
                    padding: "0px"
                }}
            >
                <Layout
                    style={{
                        height: '100vh',
                        backgroundColor: 'transparent'
                    }}
                >
                    <Sider
                        width={this.props.siderOffset}
                        style={{
                            padding: '15px'
                        }}
                    >


                        <center>
                            <Tag
                                color="#011529"
                                style={{
                                    width: '100%'
                                }}
                                icon={<InfoCircleOutlined />}
                            >Active Layer: {this.props.activeLayerName}</Tag>
                            <br />
                            <Row>
                                <Col span={8}>
                                    <Button
                                        onClick={this.props.StampScene}
                                        size="small"
                                        shape="round"
                                        icon={<FormatPainterOutlined />}
                                        style={this.state.btnStyle}>Stamp</Button>
                                </Col>
                                <Col span={16}>
                                    <Checkbox
                                        defaultChecked={this.state.groundVisible}
                                        onChange={this.toggleGroundVisibility}
                                        style={{
                                            margin: '10px',
                                            color: 'white'
                                        }}
                                    >Show Ground</Checkbox>
                                </Col>
                            </Row>


                        </center>

                        <div
                            style={{
                                maxHeight: '500px',
                                overflow: 'auto'
                            }}>

                            <Tabs defaultActiveKey="1" tabPosition="top" style={{color:'white' }}>
                                {Object.keys(this.state.grouping).map((key, index) => (
                                    <TabPane tab={key} key={key}>
                                        <Collapse
                                            accordion>
                                            {
                                                this.state.grouping[key].map((index) => (
                                                    <Panel header={this.state.controlConfig[index]["name"]} key={index}>
                                                        {
                                                            Object.keys(this.state.modelBones[index]).map((key, idx) => (
                                                                this.renderComponentPanel(key, index, this.state.modelBones[index])
                                                            ))
                                                        }
                                                    </Panel>
                                                ))
                                            }

                                        </Collapse>
                                    </TabPane>
                                ))}
                            </Tabs>
                            <div id="custom_pose_controller" >

                            </div>
                        </div>

                    </Sider>
                    <Layout
                        style={{
                            height: '100vh',
                            backgroundColor: 'transparent'
                        }}
                    >
                        <Content
                            style={{
                                height: '100vh',
                                backgroundColor: 'transparent'
                            }}
                        >
                            {this.props.Drawer3DVisisble ?
                                (<Canvas
                                    gl={{ preserveDrawingBuffer: true }} // That's all you need to do to extract image! Awesome!
                                    id="3d_canv">
                                    <ambientLight color="#2b4d6d" />
                                    <spotLight
                                        intensity={1}
                                        position={[40, 50, 50]}
                                        shadow-bias={-0.00005}
                                        penumbra={1}
                                        angle={Math.PI / 6}
                                        shadow-mapSize-width={2048}
                                        shadow-mapSize-height={2048}
                                        castShadow
                                    />
                                    <Scene
                                        load_rig={this.state.load_rig}
                                        modelBones={this.state.modelBones}
                                        groundVisible={this.state.groundVisible}
                                    />
                                </Canvas>) : null}
                        </Content>
                    </Layout>
                </Layout>
            </Drawer >
        );
    }
};